// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tab-pane[data-v-42b08c64],.num[data-v-42b08c64]{font-size:24px}.num[data-v-42b08c64]{font-weight:700;color:red}.num[data-v-42b08c64]:hover{color:#409eff}[data-v-42b08c64] .el-tabs__item{font-size:24px}[data-v-42b08c64] .is-active{background-color:#64b0ff;border-radius:5px 5px 0 0;color:#fff}[data-v-42b08c64] .el-tabs__header{margin:0}.view-TeachingStatistics[data-v-42b08c64]{padding-top:20px}", ""]);
// Exports
module.exports = exports;
